export default {
  title: '生産バッチを選択',
};
